module.exports = __webpack_public_path__ + "static/media/ios-checkmark-circle-outline.c4d4981c.svg";